import cn from 'classnames';
import React from 'react';

import Grid, { GridProps } from 'components/Grid';
import styles from './ThreeByOneWidgetGrid.module.scss';

type PickedGridProps = Pick<GridProps, 'gutter' | 'orientation'>;

export interface ThreeByOneWidgetGridProps extends PickedGridProps {
  children?: React.ReactNode;
  className?: string;
}

const ThreeByOneWidgetGrid = React.forwardRef<
  HTMLDivElement,
  ThreeByOneWidgetGridProps
>(({ children, className, gutter, orientation }, ref) => (
  <Grid
    className={cn(styles.grid, className)}
    {...{ gutter, orientation, ref }}
  >
    {children}
  </Grid>
));

export default ThreeByOneWidgetGrid;
